<template>
    <main class="main__profile__page__wrapper">
        <div class="rlms-container group__box">
            <aside class="profile__sidebar__box">
                <div class="user__profile__detail__box">
                    <div class="profile__avatar__box">
                        <img :src="userAvatar">
                    </div>
                    <div class="profile__user__info__box">
                        <h3 class="user__name__title">{{ authStore?.user?.name }}</h3>
                        <span class="user__email">{{ email }}</span>
                        <div class="purple__trans__btn">
                            <a href="javascript:void(0)" @click="showModal = true">
                                <span class="btn__icon"><img :src="galleryIcon" alt=""></span>
                                <span class="btn__text">Change Photo</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile__logout__box">
                    <a href="javascript:void(0)" class="purple__solid__btn" @click.prevent="logout">
                        <span class="btn__icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13 8V5C13 3.89543 12.1046 3 11 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H11C12.1046 21 13 20.1046 13 19V16"
                                    stroke="#fff" stroke-width="1.5" stroke-linecap="round"></path>
                                <path
                                    d="M9 11.75C8.58579 11.75 8.25 12.0858 8.25 12.5C8.25 12.9142 8.58579 13.25 9 13.25L9 11.75ZM22.5303 13.0303C22.8232 12.7374 22.8232 12.2626 22.5303 11.9697L17.7574 7.1967C17.4645 6.90381 16.9896 6.90381 16.6967 7.1967C16.4038 7.48959 16.4038 7.96447 16.6967 8.25736L20.9393 12.5L16.6967 16.7426C16.4038 17.0355 16.4038 17.5104 16.6967 17.8033C16.9896 18.0962 17.4645 18.0962 17.7574 17.8033L22.5303 13.0303ZM9 13.25L22 13.25L22 11.75L9 11.75L9 13.25Z"
                                    fill="#fff"></path>
                            </svg>
                        </span>
                        <span class="btn__text">Logout</span>
                    </a>
                </div>
            </aside>

            <section class="profile__details__box__wrapper confirm__data__form__wrapper">
                <div class="profile__detail__title__box">
                    <h3 class="title">Profile Details</h3>
                    <div class="profile__edit__info">
                        <a href="javascript:void(0)" @click="toggleEdit">
                            <span class="btn__icon">
                                <img :src="editIcon" alt="" />
                            </span>
                            <span class="btn__text">Edit info</span>
                        </a>
                    </div>
                </div>

                <form @submit.prevent="onSubmit">
                    <!-- Personal Info -->
                    <div class="profile__information__wrapper join__form__wrapper">
                        <h6 class="sub__title">Personal Information</h6>
                        <div class="form__group__field">
                            <div class="input__field">
                                <label>First Name</label>
                                <input type="text" placeholder="First Name" v-model.trim="firstname"
                                    :readonly="!editing" />
                                <span class="error__message" v-if="submitted && firstnameError">{{
                                    firstnameError }}</span>
                            </div>
                            <div class="input__field">
                                <label>Last Name</label>
                                <input type="text" placeholder="Last Name" v-model.trim="lastname"
                                    :readonly="!editing" />
                                <span class="error__message" v-if="submitted && lastnameError">{{ lastnameError
                                    }}</span>
                            </div>
                        </div>

                        <div class="form__group__field">
                            <div class="input__field">
                                <label>Phone Number</label>
                                <input type="text" id="country_code" v-model="country_code"
                                    style="display: none !important;">
                                <input type="text" id="dial_code" v-model="dial_code" style="display: none !important;">
                                <div class="phone__number__field" style="width: 100%;">
                                    <input type="text" id="phoneInput" placeholder="Phone Number" v-model="phone"
                                        maxlength="10" @input="sanitizePhone" :readonly="!editing" />
                                </div>
                                <span class="error__message" v-if="submitted && phoneError">{{ phoneError
                                    }}</span>
                            </div>
                            <div class="input__field">
                                <label>Professional Role</label>
                                <select v-model="professional_role" :readonly="!editing" :disabled="!editing">
                                    <option value="">Select your professional role</option>
                                    <optgroup v-for="group in roleGroups" :key="group.label" :label="group.label">
                                        <option v-for="role in group.roles" :key="role.value" :value="role.value">
                                        {{ role.name }}
                                        </option>
                                    </optgroup>
                                </select>
                                <span class="error__message" v-if="submitted && professional_roleError">{{ professional_roleError
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="profile__information__wrapper join__form__wrapper">
                        <h6 class="sub__title">Address</h6>
                        <div class="form__group__field">
                            <div class="input__field">
                                <label>State</label>
                                <input type="text" placeholder="State" v-model="state" :readonly="!editing">
                                <span class="error__message" v-if="submitted && stateError">{{ stateError }}</span>
                            </div>
                            <div class="input__field">
                                <label>Pincode</label>
                                <input type="text" placeholder="Pincode" v-model="pincode" :readonly="!editing">
                                <span class="error__message" v-if="submitted && pincodeError">{{ pincodeError }}</span>
                            </div>
                        </div>
                        <div class="form__group__field">
                            <div class="input__field">
                                <label>Address</label>

                                <input type="text" placeholder="Address" v-model="address" :readonly="!editing">
                                <span class="error__message" v-if="submitted && addressError">{{ addressError }}</span>
                            </div>
                        </div>

                    </div>

                    <!-- Buttons -->
                    <div class="save__btn__box__wrapper" v-if="editing">
                        <button class="save__changes__btn" type="button" @click="cancelEdit">
                            Cancel
                        </button>
                        <button class="save__changes__btn" type="submit" :disabled="submitting"
                            style="background-color: #44474c">
                            Save Changes
                        </button>
                    </div>
                </form>
            </section>
        </div>

        <BaseModal :visible="showModal" title="Change your photo" size="medium" id="change__your__photo__popup"
            class="change__your__photo__popup" @close="showModal = false">

            <div class="short__note__info">
                <p>This will be shown on your profile and message.</p>
            </div>

            <!-- File Upload Box -->
            <label :class="['file__upload__box__wrapper']" for="fileInput" v-if="!previewImage"
                :style="{ gap: userAvatar ? '10px' : '1rem' }">
                <template v-if="userAvatar">
                    <div class="profile__photo__crop__box">
                        <div class="user__profile__img__box">
                            <img :src="userAvatar" width="120" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="upload__icon__box">
                        <img :src="fileUploadIcon" />
                    </div>
                </template>
                <div class="upload__file__text__wrapper">
                    <label for="fileInput" style="color: #725cff;">{{ userAvatar ? 'Click here to change' : `Click here
                        to upload`
                    }}</label>
                    <input type="file" id="fileInput" accept="image/*" @change="handleImageChange"
                        style="display: none;" />
                    <p>Use a square image for best results</p>
                </div>
            </label>

            <!-- Preview + Save/Reset -->
            <div class="profile__photo__crop__box" v-if="previewImage">
                <div class="user__profile__img__box" id="imagePreview" style="box-shadow:none;">
                    <img :src="previewImage" alt="Preview"
                        style="max-width: 100%; max-height: 200px; border-radius: 10px;" />
                </div>
                <div class="img__crop__control__box">
                    <div class="crop__control__options">
                        <span class="img__rotate__btn" @click="resetImage">
                            <img :src="resetIcon" />
                        </span>
                    </div>
                    <div class="crop__save__btn">
                        <button class="profile__save__btn" @click="saveImage">Save</button>
                    </div>
                </div>
            </div>
        </BaseModal>
    </main>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useForm, useField } from 'vee-validate'
import * as yup from 'yup'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css';
import $ from 'jquery'
import editIcon from '@/assets/images/edit-icon.png';
import galleryIcon from '@/assets/images/gallery-icon.png'
import fileUploadIcon from '@/assets/images/file-upload-icon.png'
import resetIcon from '@/assets/images/rotate-left-icon.png'
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';
import axios from '@/services/axios';
import BaseModal from '@/components/BaseModal.vue';
import { showToast } from '@/utils/swal';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import { roleGroups } from '@/utils/format-helpers';

const router = useRouter();
const authStore = useAuthStore();
const loader = useLoaderStore();

const submitting = ref(false);
const submitted = ref(false);
const editing = ref(false);

// change photo modal
const showModal = ref(false);
const selectedFile = ref(null);
const previewImage = ref(null);
const userAvatar = ref(null);
const email = ref(null);

// Replace this with props or API fetched user
const formSchema = yup.object({
    firstname: yup.string().required('Please enter your first name.'),
    lastname: yup.string().required('Please enter your last name.'),
    phone: yup.string().required('Pleas enter your phone number.').matches(/^\d{10}$/, 'Phone must be 10 digits'),
    professional_role: yup.string().required('Please select your role.'),
    state: yup.string().nullable(true).optional(),
    pincode: yup.string().nullable(true).optional(),
    address: yup.string().nullable(true).optional(),
    country_code: yup.string().nullable(true).optional(),
    dial_code: yup.string().nullable(true).optional(),
});

// Setup form with schema
const { handleSubmit, setErrors } = useForm({
    validationSchema: formSchema,
    initialValues: {
        professional_role: ""
    }
})

// Fields
const { value: firstname, errorMessage: firstnameError } = useField('firstname')
const { value: lastname, errorMessage: lastnameError } = useField('lastname')
const { value: phone, errorMessage: phoneError } = useField('phone')
const { value: state, errorMessage: stateError } = useField('state')
const { value: pincode, errorMessage: pincodeError } = useField('pincode')
const { value: address, errorMessage: addressError } = useField('address')
const { value: professional_role, errorMessage: professional_roleError } = useField('professional_role')
const { value: country_code } = useField('country_code')
const { value: dial_code } = useField('dial_code')

// Submit handler
const onSubmit = async () => {
    submitted.value = true;

    await handleSubmit(async (values) => {
        submitting.value = true;

        try {
            loader.show();
            await axios.post('/user', { ...values });

            showToast({
                icon: 'success',
                title: 'Success! ',
                text: 'Your profile information has been updated.',
            });

            authStore.fetchUser();
            editing.value = false;
        } catch (error) {
            if (error.response?.status === 422) {
                const serverErrors = error?.response?.data?.errors || {};
                const fieldErrors = {};

                Object.keys(serverErrors).forEach(key => {
                    fieldErrors[key] = serverErrors[key][0];
                });

                setErrors(fieldErrors);
            } else {
                handleError(error);
            }
        } finally {
            submitting.value = false;
            loader.hide();
        }
    })();
};

// Method
const sanitizePhone = () => {
    phone.value = phone.value.replace(/[^0-9]/g, '').slice(0, 10)
}

let iti = null

onMounted(async () => {
    fetchUser();
});

onBeforeUnmount(() => {
    if (iti) {
        iti.destroy()
    }
})

const logout = async () => {
    await authStore.logout();
    router.push('/');
}

const toggleEdit = () => {
    editing.value = true;
};

const cancelEdit = () => {
    editing.value = false;
};

// Handle file input change
const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
        selectedFile.value = file;
        const reader = new FileReader();
        reader.onload = (event) => {
            previewImage.value = event.target.result;
        };
        reader.readAsDataURL(file);
    }
};

// Reset preview and file
const resetImage = () => {
    selectedFile.value = null;
    previewImage.value = null;
    document.getElementById('fileInput').value = '';
};

// Save Image (replace with actual API call)
const saveImage = async () => {
    if (!selectedFile.value) return;

    try {
        loader.show();

        const formData = new FormData();
        formData.append('image', selectedFile.value);

        await axios.post('/user/update-profile-pic', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        showToast({
            icon: 'success',
            title: 'Success! ',
            text: 'Your profile information has been updated.',
        });

        await fetchUser();

        editing.value = false;

        showModal.value = false;
        selectedFile.value = null;
        previewImage.value = null;
    } catch (error) {
        if (error.response?.status === 422) {
            const serverErrors = error?.response?.data?.errors || {};
            const fieldErrors = {};

            Object.keys(serverErrors).forEach(key => {
                fieldErrors[key] = serverErrors[key][0];
            });

            setErrors(fieldErrors);
        } else {
            handleError(error);
        }
    } finally {
        submitting.value = false;
        loader.hide();
    }
};

const fetchUser = async () => {
    try {
        loader.show();

        await authStore.fetchUser();
        const user = authStore?.userinfo;

        email.value = user?.email;
        firstname.value = user?.firstname;
        lastname.value = user?.lastname;
        phone.value = user?.phone;
        state.value = user?.state;
        pincode.value = user?.pincode;
        address.value = user?.address;
        country_code.value = user?.country_code;
        dial_code.value = user?.dial_code;
        userAvatar.value = user?.profilePicture;
        professional_role.value = user?.professional_role ?? "";

        await nextTick();
        iti = intlTelInput($('#phoneInput')[0], {
            initialCountry: 'us',
            separateDialCode: true
        });

        if (country_code.value) {
            iti.setCountry(country_code.value);
            // Set default values from iti instance:
            const countryData = iti.getSelectedCountryData();

            country_code.value = countryData.iso2;  // e.g. 'us'
            dial_code.value = `${countryData.dialCode}`;  // e.g. '+1'
        }

        // Listen for country change event to update reactive vars
        $('#phoneInput').on('countrychange', function () {
            const newCountryData = iti.getSelectedCountryData();
            country_code.value = newCountryData.iso2;
            dial_code.value = `${newCountryData.dialCode}`;
        });
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}
</script>
<style>
input[readonly],
select[readonly] {
    background-color: rgb(238, 238, 240);
}
</style>